import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { type UsersRequest, type UserResponse, UsersApi, RequestStrategyEnum, type WithSignal } from '@shared/api';

const getUsersEffect = createEffect(({ signal, ...request }: WithSignal<UsersRequest> = {}) => UsersApi.getUsers(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<UserResponse[]>([])
  .on(getUsersEffect.done, (current, data) => data.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getUsersEffect.pending, (_, data) => data)
  .on(getUsersEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getUsersEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getUsersEffect, () => null)
  // .on(getUsersEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getUsersEffect.fail, (_, data) =>
    ApiUtils.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while fetching Users. Please try again.'),
  )
  .on(getUsersEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

const getUsersApi = ApiUtils.wrapperApi(getUsersEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getUsersApi.cancel());

export const $usersListStore = {
  events: {
    getUsers: getUsersApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
